<!-- Screenname:Store Main Tab
Developer Name:Tharuni.
Created date on:1/02/2023
Last Working date on:
Comments and Suggestions:
TS File:StoreService -->
<template>
  <div>
    <b-form @submit.prevent="IsSubmitMain">
      <b-row>
        <b-col lg="3" md="4" sm="6" cols="12">
          <div class="field">
            <TextField v-model="dataModel.Code" class="DS-Id" type="text" placeholder="" disabled name="Code"
              :label="$t('5000.storeid')" id="Code" />
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col lg="4" md="6" sm="8" cols="12">
          <div class="field">
            <TextField v-model="dataModel.Name" class="DS-Id" type="text" placeholder="" name="Store Name"
              :label="$t('5000.storename')" :rules="{ required: true }" :required-icon="true" id="Store Name"
              :autofocus="true" case="Capital" />
          </div>
        </b-col>
        <b-col lg="4" md="4" sm="8" cols="12">
          <div class="field">
            <MultiSelectDropDown v-model="selectOptions.branchId" :items="selectOptions.branchOptions"
              :label="$t('5000.StoreBranch')" :rules="{ required: true }" :required-icon="true" id="Store Branch"
              name="Store Branch" />
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col lg="4" md="4" sm="8" cols="12">
          <div class="field">
            <!-- {{selectOptions.MappingbranchId}} -->
            <MultiSelectDropDown v-model="selectOptions.MappingbranchId" :items="selectOptions.MappingbranchOptions"
              :label="$t('5000.MappingBranch')" :rules="{ required: false }" :required-icon="false" id="Branch mapping"
              @update:modelValue="LoadSubStore" name="Branch mapping" />
          </div>
        </b-col>
        <b-col lg="4" md="4" sm="8" cols="12">
          <div class="field">
            <CustomDropDown v-model="managedOptions.managedValue" :items="managedOptions.options"
              @update:modelValue="managedAtOnchange" :disabled="editDisabled" id="managed" name="Managed At"
              :label="$t('5000.inventorymanagedat')" :rules="{ required: true }" :required-icon="true" />
          </div>
        </b-col>
        <b-col lg="4" md="4" sm="8" cols="12" v-if="managedOptions.managedValue == '2'">
          <div class="field">
            <Branch v-model="selectOptions.branchValue" @update:modelValue="handleUpdateValue" :disabled="editDisabled"
              id="Branch" name="Branch" />
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col lg="4" md="6" sm="8" cols="12">
          <div class="field">
            <MultiSelectDropDown v-model="selectOptions.subStoreValue" v-if="loading"
              :items="selectOptions.subStoreOptions" @update:modelValue="subStoreChange" ref="multiRef" name="Sub Store"
              :label="$t('5000.chooseSubStore')" :rules="{ required: false }" id="Sub Store" />
          </div>
        </b-col>

        <b-col lg="4" md="6" sm="8" cols="8">
          <div class="field">
            <label path="Branch">{{ $t("5000.IsZeroBill") }}</label>

            <div class="d-flex flex-wrap gap-3">
              <div class="d-flex align-items-center">
                <RadioButton v-model="selectOptions.IsZeroBill" inputId="ingredient1" name="Yes" value="true" />
                <label for="ingredient1" class="radio-label">{{
                  $t("5000.yes")
                }}</label>
              </div>
              <div class="d-flex align-items-center">
                <RadioButton v-model="selectOptions.IsZeroBill" inputId="ingredient2" name="No" value="false" />
                <label for="ingredient2" class="radio-label">{{
                  $t("5000.no")
                }}</label>
              </div>
            </div>
          </div>
        </b-col>


        <b-col lg="4" md="6" sm="8" cols="8">
          <div class="field">
            <label path="Branch">{{ $t("5000.isstoresupplier") }}</label>

            <div class="d-flex flex-wrap gap-3">
              <div class="d-flex align-items-center">
                <RadioButton v-model="selectOptions.IsStoreSupplier" inputId="ingredient1" name="Yes" value="true" />
                <label for="ingredient1" class="radio-label">{{
                  $t("5000.yes")
                }}</label>
              </div>
              <div class="d-flex align-items-center">
                <RadioButton v-model="selectOptions.IsStoreSupplier" inputId="ingredient2" name="No" value="false" />
                <label for="ingredient2" class="radio-label">{{
                  $t("5000.no")
                }}</label>
              </div>
            </div>
          </div>
        </b-col>

      </b-row>

      <b-row>
        <b-row class="pe-0">
          <b-col lg="12" md="12" sm="12" cols="12" class="pe-0">
            <div class="field">
              <Description v-if="loading" v-model="dataModel.Remarks" ref="childref" name="Description"
                :label="$t('5000.description')" :rules="{ required: false }" id="Description" />
            </div>
          </b-col>
        </b-row>
      </b-row>
      <b-row>
        <b-col>
          <Footer @cancel="IsClear()" :cancelhide="false" :label="label" :loading="Saveloader" />
        </b-col>
      </b-row>
    </b-form>
  </div>
  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <AlreadyExist :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch } from "vue";

import Description from "../../../../../../../components/FormComponents/TextArea.vue";
import Cancel from "../../../../../../../components/GeneralButtons/CancelButtton.vue";
import Save from "../../../../../../../components/GeneralButtons/SaveButton.vue";

import Success from "../../../../../../../components/FormComponents/createdsuccessfully.vue";
import Branch from "../../../../../../../components/FormComponents/BranchDropdown.vue";
import commonservice from "../../../../../Service/StoreService";
import common from "../../../../../Service/CommonService";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import AutoComplete from "../../../../../../../components/FormComponents/AutoComplete.vue";
import CustomDropDown from "../../../../../../../components/FormComponents/Dropdown.vue";
import MultiSelectDropDown from "../../../../../../../components/FormComponents/MultiSelectDropdown.vue";
import TextField from "../../../../../../../components/FormComponents/TextInput.vue";
import Footer from "../../../../../../../components/FormComponents/Footer.vue";
import { result } from "lodash";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import CreateSuccessully from "../../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import AlreadyExist from "../../../../../../../components/FormComponents/AlreadyExist.vue";
import GetCode from "../../../../../../../components/common/getcode.vue";
import Loader from "../../../../../../../components/FormComponents/Loader.vue";
import moment from "moment";
import CustomTextarea from "../../../../../../../components/FormComponents/TextArea.vue";
import LoginService from "../../../../../../../Services/LoginService";

export default defineComponent({
  components: {
    Description,
    Cancel,
    Save,
    Branch,
    Success,
    AutoComplete,
    CustomDropDown,
    MultiSelectDropDown,
    TextField,
    Footer,
    CreateSuccessully,
    UpdatedSuccessfully,
    AlreadyExist,
    Loader,
    CustomTextarea,
  },

  props: {
    MainStoreRights: {
      type: Object,
      default: {},
    },
  },

  setup(props) {
    debugger;

    /*Declaration starts*/
    const { t } = useI18n();
    let loading = ref(false);
    let Saveloader = ref(false);
    const routes = useRouter();
    const router = useRoute();
    console.log(router.query);
    const storeId = router.query.storeId;
    const storeType = router.query.storeType;
    const childref = ref();
    const multiRef = ref();
    const label = ref(t("btn.save"));

    watch(
      () => t("btn.save"),
      (newValue) => {
        label.value = newValue;
      }
    );

    let diffArray: any = [];
    let session: any = localStorage.getItem("UsersData");
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    let EntityData: any = localStorage.getItem("EntityData");

    session = JSON.parse(session);
    EntityData = JSON.parse(EntityData);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    let AddressVar = String(session.AddressVar);
    let EntityId = Number(EntityData.EntityId);
    let hiddenArray: any = ref([]);
    let BranchArray: any = ref([]);
    const { handleSubmit, errors, validate } = useForm();
    const editDisabled = ref(false);
    const alreadyexistpop = ref(false);

    const showmodalref = ref(false);
    const route = useRouter();
    // const message = useMessage();
    let subStoreOptionsCopy = [];

    const dataModel = ref({
      Code: "",
      Name: "",
      BranchId: BranchId,
      IsBranchId: 0,
      ManagedBy: 0,
      Remarks: "",
      StoreTypeID: 1,
      CreatedBy: 0,
      ModifiedBy: 0,
      HospitalId: HospitalId,
      CreatedAt: "",
      ModifiedAt: "",
      Id: 0,
      EntityId: 0,
      EntityOperationId: 0,
      Address: "",
      BillingAddress: "",
      IsZeroBill: false,
      IsStoreSupplier: false
    });

    const copydataModel = JSON.parse(JSON.stringify(dataModel.value));

    // Assign the copied object to a new variable
    //const newObj = copiedObj;

    const selectOptions: any = ref({
      manage_options: [],
      managedAt: "",
      branchValue: ref(),
      subStoreOptions: [],
      subStoreValue: ref(),
      branchId: ref(),
      branchOptions: [],
      MappingbranchId: ref([]),
      MappingbranchOptions: [],
      IsZeroBill: "false",
      IsStoreSupplier: "false",
    });

    const managedOptions = ref({
      options: [
        { name: "Hospital", value: 1 },
        { name: "Branch", value: 2 },
      ],
      managedValue: ref(),
    });

    const BranchObjVal = ref({
      Id: 0,
      BranchId: 0,
      StoreId: 0,
    });

    const copyselectOptions = JSON.parse(JSON.stringify(selectOptions.value));
    const successpop = ref(false);
    const updatepop = ref(false);
    let Rights: any = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
    });

    onMounted(async () => {
      ReadyFunction();
    });

    watch(
      props,
      (newValue: any) => {
        debugger;
        Object.keys(newValue.MainStoreRights).forEach((key) => {
          if (newValue.MainStoreRights[key])
            Rights.value[key] = newValue.MainStoreRights[key];
        });
        // console.log("props Changed", newValue.MainStoreRights);
        // Rights.value.Create = newValue.MainStoreRights.Create;
        // Rights.value.Update = newValue.MainStoreRights.Update;
        // Rights.value.Read = newValue.MainStoreRights.Read;
        // Rights.value.Delete = newValue.MainStoreRights.Delete;
        // Rights.value.CreateId = newValue.MainStoreRights.CreateId;
        // Rights.value.UpdateId = newValue.MainStoreRights.UpdateId;
        // Rights.value.ReadId = newValue.MainStoreRights.ReadId;
        // Rights.value.DeleteId = newValue.MainStoreRights.DeleteId;
        GetCode();
      },
      { deep: true }
    );

    async function GetCode() {
      debugger;
      let EntityData: any = localStorage.getItem("EntityData");
      EntityData = JSON.parse(EntityData);
      let EntityId = Number(EntityData.EntityId);

      let data = {
        EntityId: EntityId,
        HospitalId: HospitalId,
        BranchId: BranchId,
        StoreId: 0,
      };
      let result: any = await common.getCodeTemplate(data);
      console.log(result);
      dataModel.value.Code = result;
    }

    async function ReadyFunction() {
      await LoadBranch();
      debugger;
      try {
        debugger;

        Object.keys(props.MainStoreRights).forEach((key) => {
          if (props.MainStoreRights[key])
            Rights.value[key] = props.MainStoreRights[key];
        });
        if (storeType == "1" && storeId != null) {
          label.value = t("btn.update");
          const result = await commonservice.getStore(
            storeId,
            Number(router.query.StoreBranchId)
          );
          debugger;
          console.log(result);
          let resFields = result["result"];


          // selectOptions.value.MappingbranchId = resFields[0].MappingBranchId;

          // Ensure MappingBranchId is an array of numbers
          const mappingBranchIds = Array.isArray(resFields[0].MappingBranchId)
            ? resFields[0].MappingBranchId
            : [];

          // Filter the array to include only valid options
          selectOptions.value.MappingbranchId = mappingBranchIds.filter(id =>
            selectOptions.value.MappingbranchOptions.some(option => option.value === id)
          );


          Object.keys(dataModel.value).forEach((key) => {
            if (resFields[0][key]) dataModel.value[key] = resFields[0][key];
          });
          let selectedSubStore: any = [];

          const intArray: any = resFields[0].SubStoreId.map((str) =>
            parseInt(str)
          );

          managedOptions.value.managedValue = resFields[0].ManagedBy;
          selectOptions.value.branchValue = resFields[0].IsBranchId;

          selectOptions.value.IsZeroBill =
            resFields[0].IsZeroBill == true ? "true" : "false";

          selectOptions.value.IsStoreSupplier =
            resFields[0].IsStoreSupplier == true ? "true" : "false";

          const result1 = await commonservice.GetBranchByStore(storeId);
          console.log(result1);
          let resFields1 = result1["result"].map((str) => parseInt(str));

          // selectOptions.value.branchId = resFields1;

          // Ensure MappingBranchId is an array of numbers
          const BranchIds = Array.isArray(resFields1)
            ? resFields1
            : [];

          // Filter the array to include only valid options
          selectOptions.value.branchId = BranchIds.filter(id =>
            selectOptions.value.branchOptions.some(option => option.value === id)
          );

          await LoadSubStore();
          for (let i = 0; i < result["result"][0].SubStoreId.length; i++) {
            const foundItem: any = selectOptions.value.subStoreOptions.find(
              (item: any) =>
                item.Id === Number(result["result"][0].SubStoreId[i]) &&
                item.StoreBranchMapId ===
                Number(result["result"][0].SubStoreBranchMapId[i])
            );
            if (foundItem) {
              selectedSubStore.push({
                Id: Number(result["result"][0].SubStoreId[i]),
                StoreBranchMapId: foundItem.StoreBranchMapId,
              });
            }
          }
          selectOptions.value.subStoreValue = selectedSubStore;
          hiddenArray.value.push(resFields1);
          diffArray = selectedSubStore;

          loading.value = true;
        } else {
          loading.value = true;
          GetCode();
        }
      } catch (error) {
        console.error(error);
      }
    }

    function managedAtOnchange() {
      debugger;

      dataModel.value.ManagedBy = Number(managedOptions.value.managedValue);
      dataModel.value.Address =
        dataModel.value.ManagedBy == 1 ? AddressVar : "";
      selectOptions.value.branchValue = null;
      selectOptions.value.subStoreOptions = subStoreOptionsCopy;
    }

    //Branch Dropdown Change Function
    async function handleUpdateValue(value: string) {
      debugger;
      try {
        dataModel.value.IsBranchId = parseInt(value);

        // selectOptions.value.subStoreOptions = subStoreOptionsCopy.filter(
        //   (item: any) =>
        //     item.IsBranchId == selectOptions.value.branchValue ||
        //     item.ManagedBy == 1
        // );

        if (storeId == null) {
          selectOptions.value.manage_options = [];
          selectOptions.value.managedAt = "";
        }
      } catch { }
    }

    //User Loading
    async function LoadUser() {
      debugger;
      try {
        selectOptions.value.manage_options = [];
        console.log(selectOptions.value.managedAt);
        let userData = {
          P_Dml_Indicator: "VUL",
          branch_id: dataModel.value.BranchId,
          hospital_id: "USH00005",
          service_name: selectOptions.value.managedAt,
        };
        let result = await commonservice.getUser(userData);
        console.log(result);
        selectOptions.value.manage_options = result.data.map((v) => ({
          label: v["first_name"],
          value: v["doctor_user_id"],
        }));
      } catch (error) { }
    }

    //Inventory Managed By
    function handleMangedValue(data: any) {
      debugger;

      dataModel.value.ManagedBy = parseInt(data.value.value);
    }

    function onKeyUp(event: KeyboardEvent) {
      debugger;

      if (event.altKey && event.key == "m") {
        IsSubmitMain();
      } else if (
        event.key == "Escape" &&
        (successpop.value == true || updatepop.value == true)
      ) {
        closetrigger();
      } else if (event.key == "Escape" && alreadyexistpop.value == true) {
        alreadyclosetrigger();
      }
    }

    //Submit Click
    const IsSubmitMain = async () => {
      debugger;
      Saveloader.value = true;
      let StoreBranchMapResponse: any;

      // Run validation on all fields
      const results = await validate();

      if (!results.valid) {
        const form = document.querySelector("form");
        const allFormFields: any = form?.querySelectorAll("[id]");
        console.log("All form fields:", allFormFields);

        const errorFields = Object.keys(results.errors);
        const firstErrorField = errorFields[0];
        console.log("First error:", firstErrorField);

        for (const field of allFormFields) {
          console.log("Checking field:", field.id);
          if (field.id === firstErrorField) {
            const component = field.closest(".field");

            if (!component) continue;

            if (component.querySelector(".p-calendar")) {
              const calendar = component.querySelector(".p-calendar input");
              if (calendar) {
                calendar.focus();
                calendar.click();
              }
            } else if (component.querySelector(".p-dropdown")) {
              const dropdown = component.querySelector(".p-dropdown");
              if (dropdown) {
                dropdown.click();
                dropdown.querySelector(".p-dropdown-trigger")?.click();
              }
            } else if (component.querySelector(".p-multiselect")) {
              const multiselect = component.querySelector(".p-multiselect");
              if (multiselect) {
                multiselect.click();
                multiselect.querySelector(".p-multiselect-trigger")?.click();
              }
            } else if (component.querySelector(".p-autocomplete")) {
              const autocomplete = component.querySelector(
                ".p-autocomplete input"
              );
              if (autocomplete) {
                autocomplete.focus();
                autocomplete.click();
              }
            } else {
              const input = component.querySelector("input, textarea");
              if (input) {
                input.focus();
                if (
                  input.type === "text" ||
                  input.type === "email" ||
                  input.tagName.toLowerCase() === "textarea"
                ) {
                  input.select();
                }
              }
            }

            component.scrollIntoView({ behavior: "smooth", block: "center" });
            break;
          }
        }

        Saveloader.value = false;
        return;
      }

      debugger;
      try {
        debugger;
        dataModel.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        dataModel.value.ModifiedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        dataModel.value.BranchId = BranchId;
        dataModel.value.HospitalId = HospitalId;
        dataModel.value.ModifiedBy = UserId;
        dataModel.value.CreatedBy = UserId;

        dataModel.value.IsBranchId = dataModel.value.IsBranchId || 0;

        dataModel.value.IsZeroBill = selectOptions.value.IsZeroBill == "true";

        dataModel.value.IsStoreSupplier = selectOptions.value.IsStoreSupplier == "true";


        let EntityData: any = localStorage.getItem("EntityData");
        EntityData = JSON.parse(EntityData);
        let EntityId = Number(EntityData.EntityId);
        dataModel.value.EntityId = EntityId;

        console.log(dataModel.value);
        let result: any;
        let msg: String = "";
        let id: any = 0;

        if (storeId != null) {
          dataModel.value.EntityOperationId = Rights.value.UpdateId;
          result = await commonservice.updateStore(dataModel.value);
          msg = "Updated Successfully";
          id = storeId;
        } else {
          dataModel.value.EntityOperationId = Rights.value.CreateId;
          result = await commonservice.insertStore(dataModel.value);
          msg = "Inserted Successfully";
          id = result["result"];
        }
        console.log(result);
        debugger;
        let message = result["ErrorInfo"].ErrorCode;

        if (result["result"] == "Already" && message == null) {
          Saveloader.value = false;
          alreadyexistpop.value = true;
        } else if (message == null) {
          let branchIdValue: any = selectOptions.value.branchId ?? "";
          let dataarr: any = [];
          for (let i = 0; i < branchIdValue.length; i++) {
            let obj: any = {};
            obj["BranchId"] = branchIdValue[i];
            (obj["StoreId"] = parseInt(id)),
              (obj["CreatedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
              (obj["ModifiedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
              (obj["ModifiedBy"] = UserId),
              (obj["CreatedBy"] = UserId);
            dataarr.push(obj);
          }
          StoreBranchMapResponse = await commonservice.insertStoreBranchMapping(
            dataarr
          );
          let messageMap = StoreBranchMapResponse["ErrorInfo"].ErrorCode;
          //
          let resultmap: any;
          if (selectOptions.value.subStoreValue != undefined) {
            let storeValue = selectOptions.value.subStoreValue ?? "";
            let StoreIdbrMapId = StoreBranchMapResponse["result"].filter(
              (item: any) => item.BranchId == BranchId
            );
            for (let i = 0; i < storeValue.length; i++) {
              let dataModelMapping = {
                StoreId: parseInt(id),
                StoreMappingId: storeValue[i].Id,
                CreatedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                ModifiedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                ModifiedBy: UserId,
                CreatedBy: UserId,
                StoreBranchMapId: storeValue[i].StoreBranchMapId,
                StoreIdbrMapId: StoreIdbrMapId[0].Id,
              };
              result = await commonservice.insertStoreMapping(dataModelMapping);
            }
          }

          if (messageMap == null) {
            if (storeId != null) {
              Saveloader.value = false;
              updatepop.value = true;
            } else {
              Saveloader.value = false;
              successpop.value = true;
            }
          }
        }
      } catch (error) {
        alert(error);
        Saveloader.value = false;
      }
    };

    //Created Sucessfully Popup-Close
    function closetrigger() {
      routes.push({
        name: "StoreMaster",
      });
    }

    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
      dataModel.value.Name = "";
    }

    //clear function
    function IsClear() {
      debugger;
      Object.assign(dataModel.value, copydataModel);
      Object.assign(selectOptions.value, copyselectOptions);
      managedOptions.value.managedValue = null;
      GetCode();
    }

    //Sub Store Multi Select Load function
    async function LoadSubStore() {
      debugger;

      //  selectOptions.value.subStoreOptions.length = 0
      //  selectOptions.value.subStoreValue = ref();

      if (selectOptions.value.MappingbranchId.length != 0) {
        debugger;
        let result = await commonservice.ListByBranchId(
          usersData.UserId,
          usersData.OrganizationId,
          usersData.Admin,
          selectOptions.value.MappingbranchId.join(",")
        );

        selectOptions.value.subStoreOptions = result["result"]
          .filter((item) => item.StoreTypeId === 2 && item.IsActive == true)
          .map((item) => {
            item.name = item.Name + "(" + item.CurrentBranchName + ")";
            item.value = {
              Id: item.Id,
              StoreBranchMapId: item.StoreBranchMapId,
            };
            return item;
          });

        subStoreOptionsCopy = JSON.parse(
          JSON.stringify(selectOptions.value.subStoreOptions)
        );
      } else {
        selectOptions.value.subStoreOptions = [];
      }
    }

    //Sub Store Change
    function subStoreChange(value: string) {
      debugger;

      console.log(selectOptions.value.subStoreValue);
      console.log(diffArray);
    }

    async function LoadBranch() {
      debugger;
      const dataModel = {
        Dml_Indicator: "LBRAN",
        hospital_id: "USH00005",
      };
      const data_response = await LoginService.GetBranchesByUserId(
        usersData.UserId
      );

      selectOptions.value.branchOptions = data_response["result"].map(
        (item) => {
          item.name = item.BranchName;
          item.value = item.BranchId;
          return item;
        }
      );
      selectOptions.value.MappingbranchOptions = data_response["result"].map(
        (item) => {
          item.name = item.BranchName;
          item.value = item.BranchId;
          return item;
        }
      );
    }

    return {
      LoadBranch,
      multiRef,
      loading,
      dataModel,
      selectOptions,
      LoadUser,
      handleUpdateValue,
      handleMangedValue,
      subStoreChange,
      showmodalref,
      showpopModal: showmodalref,
      LoadSubStore,
      childref,
      successroute() {
        if (showmodalref.value == true) {
          route.push({ name: "StoreMaster" });
        } else {
        }
      },
      IsSubmitMain,
      successpop,
      updatepop,
      closetrigger,
      editDisabled,
      alreadyclosetrigger,
      alreadyexistpop,
      managedOptions,
      managedAtOnchange,
      IsClear,
      label,
      Saveloader,
      Rights,
      hiddenArray,
      BranchArray,
    };
  },
});
</script>
